/**
 * LoadMore component is used for loading more items by clicking "load more” button
 *
 * @attr {String} load-more-text - text for load more button
 * @attr {String} numbers-separator-text - text is used to separate total amount and displayed amount of items
 * @attr {string} store-name - The name of the store that is managed by component
 *
 * */

import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { actions, selectors } from '@elab/core/store/pagination';

class LoadMore extends SimpleLitElement {
    static get properties() {
        return {
            storeName: {
                type: String,
                attribute: 'store-name',
            },
            loadMoreText: { type: String, attribute: 'load-more-text' },
            numbersSeparatorText: {
                type: String,
                attribute: 'numbers-separator-text',
            },
            pagination: { type: Object, attribute: false },
            additionalPagination: { type: Boolean, attribute: 'additional-pagination' },
        };
    }

    constructor() {
        super();
        this.currentPage = 0;
        this.numbersSeparatorText = '';
        this.loadMoreText = '';
        this.additionalPagination = false;
    }

    handleLoadMore() {
        this.currentPage = this.currentPage + 1;
        this.dispatchEvent(
            new CustomEvent('add-one-more-page', {
                detail: {
                    page: this.currentPage,
                    size: this.pagination.pageSize,
                },
            }),
        );
    }

    renderLoadMoreButton() {
        return this.pagination.currentPage + 1 !== this.pagination.totalPages
            ? html`
                  <e2-button
                      no-arrow
                      full-width
                      class="content-list__button"
                      @click="${this.handleLoadMore}"
                  >
                      ${this.loadMoreText}
                  </e2-button>
              `
            : null;
    }

    render() {
        let currentResult = 0;
        let totalResults = 0;
        if (
            typeof this.pagination.currentPage !== 'undefined' &&
            typeof this.pagination.pageSize !== 'undefined' &&
            typeof this.pagination.totalPages !== 'undefined' &&
            typeof this.pagination.totalResults !== 'undefined'
        ) {
            totalResults = this.pagination.totalResults;
            if (this.pagination.currentPage + 1 === this.pagination.totalPages) {
                currentResult = this.pagination.totalResults;
            } else {
                currentResult = (this.pagination.currentPage + 1) * this.pagination.pageSize;
            }
        }
        return html`
            <div class="content-list__numbers">
                ${currentResult} ${this.numbersSeparatorText} ${totalResults}
            </div>
            ${totalResults ? this.renderLoadMoreButton() : ''}
        `;
    }
}

const mapDispatchToEvents = (dispatch, ctx) => ({
    'add-one-more-page': ({ detail }) => {
        ctx.additionalPagination
            ? dispatch(actions.addPageForOfflineOrders(ctx.storeName, detail))
            : dispatch(actions.addOneMorePage(ctx.storeName, detail));
    },
});

const mapStateToProps = (state, ctx) => ({
    pagination: ctx.additionalPagination
        ? selectors.getAdditionalPagination(state, ctx.storeName)
        : selectors.getPagination(state, ctx.storeName),
});

export default () =>
    customElements.define('e2-load-more', connect(mapStateToProps, mapDispatchToEvents)(LoadMore));
